import React from "react";
import theme from "../../theme";
import ButtonWrapper from "./ButtonWrapper";
import { ButtonProps } from "../../@types/";
import EditIcon from '@material-ui/icons/Edit';

const UpdateButton = (props: ButtonProps) => {
  return (
    <>
      <ButtonWrapper
        bgColor={theme.palette.primary.light}
        icon={<EditIcon />}
        message={"Update"}
        {...props}
      />
    </>
  );
};

export default UpdateButton;
